/* eslint-disable @typescript-eslint/no-explicit-any */
import queryString from 'query-string';

import type { SortFilter, GroupFilter, Filters } from '../../models';

type Params = {
  sort?: SortFilter;
  group?: GroupFilter;
  search?: string;
  startDate?: string;
  endDate?: string;
  [key: string]: any;
};

const ALLOWED_PARAMS = ['payableFilter', 'payableFilterId'];

export const filtersToUrlQueryString = (
  filters: Filters,
  existingSearchParams: string,
) => {
  const params: Params = {};

  if (filters.sort) {
    params.sort = filters.sort;
  }
  if (filters.group) {
    params.group = filters.group;
  }
  if (filters.search) {
    params.search = filters.search;
  }

  const queryParams = [queryString.stringify(params, { arrayFormat: 'index' })];

  if (existingSearchParams) {
    const existingAllowedParams = allowedUrlSearchParamsToObject(
      new URLSearchParams(existingSearchParams),
    );

    queryParams.unshift(
      queryString.stringify(existingAllowedParams, { encode: false }),
    );
  }

  return queryParams.join('&');
};

const allowedUrlSearchParamsToObject = (
  params: URLSearchParams,
): Record<string, string> => {
  const result: Record<string, string> = {};
  params.forEach((value, key) => {
    if (ALLOWED_PARAMS.includes(key)) {
      result[key] = value;
    }
  });
  return result;
};
